function SentArrowIcon(props)
{
    return(
        <svg className={props.class} viewBox="0 0 24 24"><g id="_20.Arrow_Right" data-name="20.Arrow Right"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z"/><polygon points="13.707 16.707 12.293 15.293 15.586 12 12.293 8.707 13.707 7.293 18.414 12 13.707 16.707"/><rect x="6" y="11" width="11" height="2"/></g></svg>
    )
}

export default SentArrowIcon